<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">
        © {{ today | date : "y" }} JáPedido. Todos os direitos reservados.
      </p>
    </div>
  </div>
</div>
